module.exports = __webpack_public_path__ + "img/id4s-logo.22b90961.png";